import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export const ConsulteEmpreendimentosHero = () => {
  const { t } = useTranslation('atendimento')
  return (
    <button type="button" className="group shadow-cz relative mb-8 h-38 w-full overflow-hidden rounded-md">
      <Link to="empreendimentos">
        <img
          src="/images/consulta_empreendimentos.png"
          alt="Interior decorado Plaenge"
          className="h-full w-full scale-115 object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/80 via-black/40 to-transparent">
          <div className="text-foreground px-6 py-4 text-left font-semibold">
            <p className="text-lg md:text-2xl">{t('components.consulte_empreendimentos.consulte_os')}</p>
            <p className="text-xl uppercase md:text-[1.75rem]">
              {t('components.consulte_empreendimentos.empreendimentos')}
            </p>
          </div>
        </div>
      </Link>
    </button>
  )
}
